export default {
  baseURL: '',
  yandexMapConfig: {
    apiKey: '8ba553ca-c4d0-4b82-b1f5-8805779f7df2',
    lang: 'ru_RU',
    coordorder: 'latlong',
    version: '2.1'
  }
}
